import { render, staticRenderFns } from "./DisLikeChart.vue?vue&type=template&id=a285c45e&scoped=true&"
import script from "./DisLikeChart.vue?vue&type=script&lang=js&"
export * from "./DisLikeChart.vue?vue&type=script&lang=js&"
import style0 from "./DisLikeChart.vue?vue&type=style&index=0&id=a285c45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a285c45e",
  null
  
)

export default component.exports